<template>
  <div class="content">
    <div class="search-area mb15">
    <div class="w100f t-left mb15"><b>基本信息</b></div>
      <el-row :gutter="24">  
        <el-col :span="7"><div class="search-area-div1">月份：{{tableData.month}}</div> </el-col> 
         <el-col :span="5"><div class="search-area-div1">批次：{{tableData.batchNum}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">通知时间：{{tableData.noticeTime | getDate}}</div> </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="7"><div class="search-area-div1">企业：{{tableData.tenantName}}</div> </el-col>
        <el-col :span="5"><div class="search-area-div1">推广费总额：{{tableData.totalAmount | numDigit | numFmt}}</div> </el-col> 
        <el-col :span="5"><div class="search-area-div1">总人数：{{reportPeopleNum}}</div> </el-col> 
      </el-row> 
      <el-row :gutter="24" v-if="tableData.approvalState =='Y'">
        <el-col :span="7"><div class="search-area-div1">审批状态：{{tableData.approvalState | approvalState}}</div> </el-col>
        <el-col :span="5"><div class="search-area-div1">审批时间：{{tableData.approvalTime | getDate}}</div> </el-col> 
      </el-row> 
    </div> 
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加岗位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <div class=" back-color-fff mt15" style="padding: 16px;">
    <div class="w100f t-left mb15">
    <b>省总提报信息</b> 
    </div> 
    <div class="button-area pd0"> 
            <el-button size="medium" type="info" @click="performanceReportApproval" v-if="tableData.approvalState =='A' || tableData.approvalState =='N'">通过</el-button>
            <el-button size="medium" type="danger" @click="dialogVisible = true" v-if="tableData.approvalState =='A' || tableData.approvalState =='N'">驳回</el-button>  
            <el-button plain size="medium" @click="toDetailLink(tableData.guid)">查看人员推广费明细</el-button>
    </div>
      <el-table :data="tableData.performanceReportVOS" border style="width: 100%; margin-top: 15px;" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="organisationNames" label="组织(只到省区)" header-align="center" align="center">
                  <template slot-scope="scope">{{ scope.row.organisationNames | roleNames}}</template>
        </el-table-column>
        <el-table-column prop="staffName" label="提报人" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="positionNames" label="提报人岗位" header-align="center" align="center">
                    <template slot-scope="scope">{{ scope.row.positionNames | roleNames}}</template>
        </el-table-column>
        <el-table-column prop="amount" label="提报金额(元)" header-align="center" align="center">
                    <template slot-scope="scope">{{scope.row.amount | numDigit | numFmt}}</template>
        </el-table-column>
        <!-- <el-table-column prop="reportPeopleNum" label="提报状态" header-align="center" align="center">
                    <template slot-scope="scope">
                          <div class="fontC-green" v-if="scope.row.reportPeopleNum >0">{{scope.row.reportPeopleNum > 0 ?'已提报':'待提报'}}</div>
                          <div v-else>{{scope.row.reportPeopleNum > 0 ?'已提报':'待提报'}}</div> 
                    </template>
        </el-table-column> -->
        <el-table-column prop="reportPeopleNum" label="提报人数" header-align="center" align="center">
                    <template slot-scope="scope">{{scope.row.reportPeopleNum==null?'-':scope.row.reportPeopleNum}}</template>
        </el-table-column> 
        <el-table-column prop="reportTime" label="提报时间" sortable header-align="center" align="center">
          <template slot-scope="scope">
                    <div v-if="scope.row.reportTime == null">-</div> 
                    <div v-else>{{scope.row.reportTime | getDate}}</div> 
          </template>
        </el-table-column> 
        <!-- <el-table-column prop="approvalState" label="审核状态" sortable header-align="center" align="center">
                    <template slot-scope="scope">
                        <div class="fontC-green" v-if="scope.row.approvalState == 'Y'">{{scope.row.approvalState | approvalState}}</div>
                        <div class="fontC-red" v-if="scope.row.approvalState == 'R'">{{scope.row.approvalState | approvalState}}</div>
                        <div v-if="scope.row.approvalState == 'N' || scope.row.approvalState == 'A'">{{scope.row.approvalState | approvalState}}</div>
                  </template>
        </el-table-column> 
        <el-table-column prop="approvalTime" label="审核时间" sortable header-align="center" align="center">
          <template slot-scope="scope">
                    <div v-if="scope.row.approvalTime == null">-</div> 
                    <div v-else>{{scope.row.approvalTime | getDate}}</div> 
                    </template>
        </el-table-column>  -->
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- <a class="txt-color" v-if="scope.row.approvalState == 'N' || scope.row.approvalState == 'A'" @click="toSubmit(scope.row.performanceReportGuid,scope.row.positionNames)">提报审核</a> -->
            <a class="txt-color" v-if="scope.row.approvalState == 'Y' || scope.row.approvalState == 'R'" @click="toDetail(scope.row.performanceReportGuid,scope.row.positionNames)">提报详情</a>  
          </template>
        </el-table-column>
      </el-table> 
      
    </div>   
    <!-- <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 30, 50]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>   -->
    <el-dialog
      title="填写驳回理由"
      :visible.sync="dialogVisible"
      width="30%">
       <el-input
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 4}"
        placeholder="请输入驳回理由"
        v-model="approvalSuggest">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button plain @click="dialogVisible = false">取 消</el-button>
        <el-button type="info" @click="performanceReportRejection">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return { 
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        orderNo: '', 
        goodsName: '', 
        franchiseeName: '', 
        customerName: '', 
        dispDetailCount: '', 
        startTime: '', 
        endTime: '', 
      },
      tableData: [],  
      timeList:'',
      reportPeopleNum:0,
      dialogVisible:false,
      approvalSuggest:'',
      tableLoading:false,
      height:window.innerHeight - 410, 
    };
  },
  created() {
    // 列表
    this.getData(false);
  }, 
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        orderNo: '', 
        goodsName: '', 
        franchiseeName: '', 
        customerName: '', 
        dispDetailCount: '', 
        startTime: '', 
        endTime: '', 
      };
      self.getData(true);
    }, 
    getData(flg) {
      let self = this; 
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msSalesPerformService}/performance/data/get-performance-detail?`+`guid=`+self.$router.history.current.query.guid).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableLoading = false;
          self.tableData = res.data.data;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
          self.reportPeopleNum = 0;
          if(self.tableData.performanceReportVOS != null && self.tableData.performanceReportVOS.length > 0){
                  self.tableData.performanceReportVOS.forEach(function(i){
                      self.reportPeopleNum += i.reportPeopleNum
                })
          } 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },   
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },  
    performanceReportApproval() {
      let self = this; 
      self.api.post(`/${serverConfig.msSalesPerformService}/performance/data/finish-performance-approval`,{'performanceGuid':self.$router.history.current.query.guid,tenantGuid:localStorage.guid}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
             self.$message.success('通过成功！');
             self.$router.push({path: "/performanceAuditingList",query:{productGuid:this.$route.query.productGuid}});
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },   
    performanceReportRejection() {
      let self = this; 
      if(this.approvalSuggest == ''){
        this.$message.error('请输入驳回理由！')
        return
      }
      self.api.post(`/${serverConfig.msSalesPerformService}/performance/data/performance-rejection`,{'performanceGuid':self.$router.history.current.query.guid,'approvalSuggest':self.approvalSuggest,tenantGuid:localStorage.guid}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
             self.$message.success('驳回成功！');
             self.$router.push({path: "/performanceAuditingList",query:{productGuid:this.$route.query.productGuid}});
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },   
    toDetail(performanceReportGuid,positionNames){
      this.$router.push({path: "/submitForReviewDetail", query:{productGuid:this.$route.query.productGuid,performanceReportGuid:performanceReportGuid,month:this.tableData.month,batchNum:this.tableData.batchNum,positionNames:positionNames,guid:this.$router.history.current.query.guid}})
    },
    toDetailLink(guid){
        this.$router.push({path: "/performanceDetailsAll", query:{productGuid:this.$route.query.productGuid,guid:guid}})
    },
  },
};
</script>
